export const MAX_PHONE_DIGITS = 11;

const AREA_CODE_LENGTH = 2;
const MOBILE_CUT = 5;
const LANDLINE_CUT = 4;
const MIN_MOBILE_DIGITS = 9;

export const onlyDigits = (value: string) =>
    value.replace(/\D/g, '').slice(0, MAX_PHONE_DIGITS);

/// Máscara progressiva: fixo tem 10 dígitos e celular 11, e uma de tamanho fixo barraria o 11º.
export const applyPhoneMask = (value: string) => {
    const digits = onlyDigits(value);

    if (digits.length === 0) return '';
    if (digits.length <= AREA_CODE_LENGTH) return `(${digits}`;

    const ddd = digits.slice(0, AREA_CODE_LENGTH);
    const number = digits.slice(AREA_CODE_LENGTH);
    const cut = number.length > MIN_MOBILE_DIGITS - 1 ? MOBILE_CUT : LANDLINE_CUT;

    return number.length <= cut
        ? `(${ddd}) ${number}`
        : `(${ddd}) ${number.slice(0, cut)}-${number.slice(cut)}`;
};

const BRAZIL_DIAL_CODE = '55';
const NATIONAL_LENGTH = 10;
const MOBILE_LENGTH = 11;

/// Tira o DDI de um número E.164 para caber no campo (DDD + número).
/// Jogar `553598773781` direto fazia a máscara ler o "55" como DDD e criava um duplicado.
export const toNational = (phone: string) => {
    const digits = phone.replace(/\D/g, '');

    if (!digits.startsWith(BRAZIL_DIAL_CODE)) return digits.slice(0, MAX_PHONE_DIGITS);

    const withoutDialCode = digits.slice(BRAZIL_DIAL_CODE.length);

    // Só corta se sobra um número nacional plausível; um fixo de SP (55 no início) perderia dígitos.
    return withoutDialCode.length === NATIONAL_LENGTH || withoutDialCode.length === MOBILE_LENGTH
        ? withoutDialCode
        : digits.slice(0, MAX_PHONE_DIGITS);
};
